export function buildCommandTeamRows({
  rows,
  assignmentsByRole,
  blockedSlots,
  publishedShiftsByRole,
  handlers
}) {
  return rows.map((row) => ({
    ...row,
    assignments: assignmentsByRole[row.roleKey] || [],
    blocked: !!blockedSlots[row.roleKey],
    publishedShifts: publishedShiftsByRole[row.roleKey] || [],
    ...handlers(row.roleKey)
  }));
}